import { render, staticRenderFns } from "./bots.vue?vue&type=template&id=4c2570b2&scoped=true&lang=pug&"
import script from "./bots.vue?vue&type=script&lang=js&"
export * from "./bots.vue?vue&type=script&lang=js&"
import style0 from "./bots.vue?vue&type=style&index=0&id=4c2570b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2570b2",
  null
  
)

export default component.exports